import { DataHeader, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFuelSurchargeCycleCodesMaster extends Layout {
    dataheaderFscCycle: DataHeader;
    panelDayofMonth: Panel;
    panelWeekdayofMonth: Panel;
    sourceFscCycle: DataSource;
    textboxCalendarDay: Textbox;
    textboxCode: Textbox;
    textboxCycleType: Textbox;
    textboxDescr: Textbox;
    textboxMonthFrequency: Textbox;
    textboxWeekDay: Textbox;
}
